/*! @azure/msal-react v3.0.16 2025-07-23 */
'use strict';

import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { AuthError } from '@azure/msal-browser';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

var ReactAuthErrorMessage = {
  invalidInteractionType: {
    code: "invalid_interaction_type",
    desc: "The provided interaction type is invalid."
  },
  unableToFallbackToInteraction: {
    code: "unable_to_fallback_to_interaction",
    desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
  }
};

var ReactAuthError =
/*#__PURE__*/
function (_AuthError) {
  _inherits(ReactAuthError, _AuthError);

  function ReactAuthError(errorCode, errorMessage) {
    var _this;

    _classCallCheck(this, ReactAuthError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactAuthError).call(this, errorCode, errorMessage));
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), ReactAuthError.prototype);
    _this.name = "ReactAuthError";
    return _this;
  }

  _createClass(ReactAuthError, null, [{
    key: "createInvalidInteractionTypeError",
    value: function createInvalidInteractionTypeError() {
      return new ReactAuthError(ReactAuthErrorMessage.invalidInteractionType.code, ReactAuthErrorMessage.invalidInteractionType.desc);
    }
  }, {
    key: "createUnableToFallbackToInteractionError",
    value: function createUnableToFallbackToInteractionError() {
      return new ReactAuthError(ReactAuthErrorMessage.unableToFallbackToInteraction.code, ReactAuthErrorMessage.unableToFallbackToInteraction.desc);
    }
  }]);

  return ReactAuthError;
}(AuthError);

export { ReactAuthError, ReactAuthErrorMessage };